import React from "react";
import ReactDOM from "react-dom";
//import { HashRouter, Route } from 'react-router-dom'
import { Provider } from "react-redux";

//import registerServiceWorker from './registerServiceWorker'
import store from "./store/configure.js";
import "./api/config/configure.js";
import App from "./containers/App";
import "./styles/index.css";
import Toaster from "./components/Common/Toaster.js";

import "core-js/fn/array/find-index";
import "core-js/fn/array/find";
import "core-js/fn/array/flatten";
import "core-js/fn/array/from";
import "core-js/fn/array/includes";
import "core-js/fn/array/reduce";
import "core-js/fn/string/pad-start";

import URLSearchParams from "url-search-params";
if (typeof window.URLSearchParams === "undefined")
  window.URLSearchParams = URLSearchParams;

ReactDOM.render(
  <Provider store={store}>
    <React.Fragment>
      {/*<HashRouter>
      <Route path="/" component={App}/>
    </HashRouter>*/}
      <App />
    </React.Fragment>
  </Provider>,
  document.querySelector("#root")
);

//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js